import type { Tracker, TrackingEvent } from '@archipro-website/tracker';
import type { MenuLabel, MenuObj } from './utils';

/** The legacy tabs, plus the revamp's Downloads tab, which legacy never had. */
type NavEventLabel = MenuLabel | 'Downloads';

const NAV_MENU_EVENT_MAP: Record<NavEventLabel, TrackingEvent | null> = {
    Profile: null,
    About: 'ProfessionalNavigationAboutClick',
    Products: 'ProfessionalNavigationProductClick',
    Projects: 'ProfessionalNavigationProjectClick',
    Spaces: null,
    Articles: 'ProfessionalNavigationArticleClick',
    Videos: 'ProfessionalNavigationVideoClick',
    Network: 'ProfessionalNavigationNetworkClick',
    Downloads: 'ProfessionalNavigationDownloadsClick',
    Contact: 'ProfessionalNavigationContactClick',
};

/**
 * Accepts any nav item with a label, not just the legacy `MenuObj`: the revamp's
 * pill tabs carry a plain `string` label. Unknown labels map to nothing and are
 * dropped by the guard below, which is the same outcome the narrow type gave.
 */
export const fireNavMenuEvent = (
    menu: Pick<MenuObj, 'label'> | { label: string },
    url: string,
    tracker: Tracker,
) => {
    const { label } = menu;
    const event = NAV_MENU_EVENT_MAP[label as NavEventLabel];
    if (!event) {
        return;
    }

    tracker.log(event, {
        url: new URL(url),
        targetTracker: 'archiproTracker',
    });
};
